import { useState, useEffect } from "react";
import axios from "axios";
import {
  createSingleCountryRequest,
  createMultiCountryRequest,
  createAllCountryRequest,
} from "./getUrl";
import { transformData } from "./handleData";

const useData = (
  toolConfig,
  entity,
  selectedCountry,
  selectedCountries,
  fuel,
  selectedYear
) => {
  const [data, setData] = useState(null);
  const [response, setResponse] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [maxValue, setMaxValue] = useState(null);

  const fetchData = () => {
    const usedVariable =
      toolConfig.dataTreatment === "absolute"
        ? toolConfig.dataset.absoluteVariable
        : toolConfig.dataset.relativeVariable;

    const maxValueUrl = toolConfig.dataset.multipleSeries
      ? `https://ember-data-api-scg3n.ondigitalocean.app/ember.json?sql=select+MAX%28${usedVariable}%29+as+max_value+from+${toolConfig.dataset.apiDatasetTitle}+WHERE+${usedVariable}%21%3D%27%27+and+variable%3D%27${fuel.value}%27+and+state+%21%3D%27%27&_shape=array`
      : `https://ember-data-api-scg3n.ondigitalocean.app/ember.json?sql=select+MAX%28${usedVariable}%29+as+max_value+from+${toolConfig.dataset.apiDatasetTitle}+WHERE+${usedVariable}%21%3D%27%27+and+state+%21%3D%27%27&_shape=array`;

    const url =
      toolConfig.chartType === "area"
        ? createSingleCountryRequest(
            toolConfig.dataset,
            entity,
            selectedCountry
          )
        : toolConfig.chartType === "line"
        ? toolConfig.comparison === "off"
          ? createSingleCountryRequest(
              toolConfig.dataset,
              entity,
              selectedCountry
            )
          : createMultiCountryRequest(
              toolConfig.dataset,
              entity,
              selectedCountries,
              fuel
            )
        : createAllCountryRequest(toolConfig.dataset, fuel, selectedYear);

    setLoading(true);
    axios
      .get(url)
      .then((res) => {
        setResponse(res.data);
        setData(transformData(toolConfig, res.data, selectedCountries));
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });

    axios.get(maxValueUrl).then((res) => {
      setMaxValue(res.data[0].max_value);
    });
  };

  useEffect(() => {
    fetchData();
  }, [
    toolConfig.dataTreatment,
    toolConfig.comparison,
    toolConfig.dataset,
    toolConfig.chartType,
    entity,
    selectedCountries,
    selectedCountry,
    fuel,
    selectedYear,
  ]);

  return { data, response, isLoading, error, maxValue };
};

export { useData };
